import { createContext } from 'react'

// Similar to StatesContext used for supplier_search,
// but since we're only interested in mapping state abbreviations => full state names
// we only need to pass a hash, rather than an array.
const StatesContext = createContext({})

export default StatesContext
